<template>
	<div>
		<div class="d-flex-between-center m-d-8">
			<div class="d-block">
				<div class="f-regular f-14 f-c-black">
					Ekstra Pengantaran
				</div>
				<div class="f-regular f-12 f-c-midgrey">
					Ditambahkan {{ $moment(pengantaranExtra.waktu_raw).format("DD MMMM YYYY HH:mm") }}
				</div>
			</div>
			<div class="d-block text-right">
				<div class="f-regular f-14 f-c-black">
					{{ formatRupiah(pengantaranExtra.biaya) }}
				</div>
			</div>
		</div>
		<div class="separator-line-dot m-t-4 m-d-12"></div>
	</div>
</template>

<script>
export default {
	name: "SOTagihanTopupEpayment",
	props: {
		pengantaranExtra: Object,
	}
}
</script>